import { Model } from '@/clients/http'

import { AddressHttpParams, AddressResponses } from '@/types'

export class AddressModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_ADDRESS_LIST',
    GET_BY_ID: 'GET_ADDRESS_BY_ID',
    CREATE: 'CREATE_ADDRESS',
    UPDATE: 'UPDATE_ADDRESS',
    DELETE: 'DELETE_ADDRESS',
  }

  public static readonly endpoints = {
    getList: (props?: AddressHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/address',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: AddressHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/address/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: AddressHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/address',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: AddressHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/address/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: AddressHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/address/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: AddressHttpParams.GetList) => {
    return this.createHttpRequest<AddressResponses.GetList, AddressResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly getById = async (props: AddressHttpParams.GetById) => {
    return this.createHttpRequest<AddressResponses.GetById, AddressResponses.GetByIdError>({
      correlationKey: this.correlations.GET_BY_ID,
      payload: {
        method: 'get',
        url: this.endpoints.getById(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly create = async (props: AddressHttpParams.Create) => {
    return this.createHttpRequest<AddressResponses.Create, AddressResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly update = async (props: AddressHttpParams.Update) => {
    return this.createHttpRequest<AddressResponses.Update, AddressResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly delete = async (props: AddressHttpParams.Delete) => {
    return this.createHttpRequest<AddressResponses.Delete, AddressResponses.DeleteError>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
